import NextPreviousAdBreakControl from './NextPreviousAdBreakControl';

// Pass mode into parent function
const PreviousAdBreakControl = NextPreviousAdBreakControl('previous');

PreviousAdBreakControl.displayName = 'PreviousAdBreakControl';
export default PreviousAdBreakControl;
